import PasswordValidator from '../ui/password-validator';
import TrackLoginEvent from '../ui/track-login-event';

export default function () {
    PasswordValidator.attachTo('[data-password-validator]');
    TrackLoginEvent.attachTo(document);
}
